export default "__VITE_ASSET__9Hqjv1Ix__"